import { Controller } from "@hotwired/stimulus";

const GAP = 8;

export default class extends Controller {
  connect() {
    this.tooltipTextElement = document.createElement("div");
    this.tooltipTextElement.setAttribute("popover", "manual");
    this.tooltipTextElement.setAttribute("role", "tooltip");
    this.tooltipTextElement.className = "wg-tooltip-text";
    document.body.appendChild(this.tooltipTextElement);

    this.handlePointerOver = this.handlePointerOver.bind(this);
    this.handlePointerOut = this.handlePointerOut.bind(this);
    this.handlePopoverEnter = this.handlePopoverEnter.bind(this);
    this.handlePopoverLeave = this.handlePopoverLeave.bind(this);
    this.reposition = this.reposition.bind(this);

    this.element.addEventListener("pointerover", this.handlePointerOver);
    this.element.addEventListener("pointerout", this.handlePointerOut);
    this.tooltipTextElement.addEventListener("pointerenter", this.handlePopoverEnter);
    this.tooltipTextElement.addEventListener("pointerleave", this.handlePopoverLeave);

    this.startTrackingViewport();
  }

  disconnect() {
    clearTimeout(this.hideTimer);

    this.element.removeEventListener("pointerover", this.handlePointerOver);
    this.element.removeEventListener("pointerout", this.handlePointerOut);
    this.tooltipTextElement.removeEventListener("pointerenter", this.handlePopoverEnter);
    this.tooltipTextElement.removeEventListener("pointerleave", this.handlePopoverLeave);
    window.removeEventListener("scroll", this.reposition, true);
    window.removeEventListener("resize", this.reposition);

    this.tooltipTextElement.remove();
    this.tooltipTextElement = null;
    this.currentTrigger = null;
  }

  handlePointerOver(event) {
    const trigger = event.target.closest("[data-tooltip]");
    if (!trigger) return;
    if (trigger === this.currentTrigger) return;
    this.show(trigger);
  }

  handlePointerOut(event) {
    const trigger = event.target.closest("[data-tooltip]");
    if (!trigger) return;
    if (trigger.contains(event.relatedTarget)) return;
    if (event.relatedTarget === this.tooltipTextElement || this.tooltipTextElement.contains(event.relatedTarget)) return;
    this.scheduleHide();
  }

  handlePopoverEnter() {
    clearTimeout(this.hideTimer);
  }

  handlePopoverLeave() {
    this.scheduleHide();
  }

  scheduleHide() {
    this.hideTimer = setTimeout(() => this.hide(), 1000);
  }

  show(trigger) {
    clearTimeout(this.hideTimer);
    const text = trigger.dataset.tooltip;
    if (!text) return;

    this.currentTrigger = trigger;
    this.tooltipTextElement.innerHTML = text;

    if (!this.tooltipTextElement.matches(":popover-open")) {
      this.tooltipTextElement.showPopover();
    }
    this.reposition();
  }

  hide() {
    this.tooltipTextElement.hidePopover();
    this.currentTrigger = null;
  }

  reposition() {
    if (!this.currentTrigger) return;

    const triggerRect = this.currentTrigger.getBoundingClientRect();
    const popoverRect = this.tooltipTextElement.getBoundingClientRect();

    let top = triggerRect.top - popoverRect.height - GAP;
    let placement = "top";
    if (top < GAP) {
      top = triggerRect.bottom + GAP;
      placement = "bottom";
    }

    const maxTop = Math.max(GAP, window.innerHeight - popoverRect.height - GAP);
    top = Math.max(GAP, Math.min(top, maxTop));

    let left = triggerRect.left + triggerRect.width / 2 - popoverRect.width / 2;
    left = Math.max(GAP, Math.min(left, window.innerWidth - popoverRect.width - GAP));

    this.tooltipTextElement.style.top = `${top}px`;
    this.tooltipTextElement.style.left = `${left}px`;
    this.tooltipTextElement.dataset.placement = placement;
  }

  startTrackingViewport() {
    window.addEventListener("scroll", this.reposition, true);
    window.addEventListener("resize", this.reposition);
  }
}
